import { Actuation, Document } from '../../../types';
import { STUDY_ACTUATION_KINDS_AVAILABLE as STUDY_ACTUATION_KINDS } from '../../../constants/actuation-kinds';

export const mapActuationsToDocuments = (
  actuations: Actuation[],
): Document[] => {
  return actuations
    .sort(
      (a, b) =>
        new Date(b.documentDate).getTime() - new Date(a.documentDate).getTime(),
    )
    .map((actuation) => ({
      id: actuation.cve,
      name: `${actuation.documentDate} - ${
        STUDY_ACTUATION_KINDS.find((kinds) => kinds.value === actuation.kind)
          ?.displayName || actuation.kind.toString()
      }`,
      content: {
        type: 'html',
        value: null,
        searchItems: [],
      },
    }));
};
